<template>
  <div>

    <page-heading :title="$t(`${translationPrefix}.title`)" :loading="fetching"></page-heading>

    <content-placeholder v-if="fetching || !app">
      <el-card>
        <p class="text text-75"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
      </el-card>
    </content-placeholder>

    <div v-else>

      <el-row :gutter="20" v-if="!subscribedPackage">
        <el-col :md="24">
          <el-alert :closable="false" title="You are currently NOT subscribed to this package. " center> 
            <router-link :to="{ name: 'appsSettings'}">
              <el-button size="mini">Go to Package Chooser</el-button>
            </router-link>
          </el-alert>
        </el-col>
      </el-row>

      <el-row :gutter="20" v-else>
        <el-col :md="18">
          <el-card>
            <div slot="header">
              {{ app.name }} [ {{ activeUsersCount }} of {{subscribedPackage.max_users}} users ]
            </div>

            <div v-if="app.user_memberships && app.user_memberships.length > 0">

              <el-table
                :data="app.user_memberships"
                style="width: 100%"
                v-if="count > 0"
                class="depth"
                :border="true">

                <el-table-column
                  label=""
                  width="40"
                  fixed="left">
                  <template slot-scope="scope">
                    <el-tooltip content="Remove this user!" placement="top">
                      <el-button size="mini" plain circle type="text" @click="removeUserMembership(scope.row.id)"><i class="fas fa-times"></i></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                  label=""
                  width="80">
                  <template slot-scope="scope">
                    <img :src="getGravatar(scope.row.invitation_email,'600')" class="image">
                  </template>
                </el-table-column>
                <el-table-column
                  label="Email"
                  prop="invitation_email">
                </el-table-column>
                <el-table-column
                  label="Sent On">
                  <template slot-scope="scope">
                    {{ scope.row.invitation_sent_at | formatTime('MMM DD, YYYY hh:mm:ss a') }} 
                  </template>
                </el-table-column>
                <el-table-column
                  label="Accepted On">
                  <template slot-scope="scope">
                    {{ scope.row.invitation_accepted_at | formatTime('MMM DD, YYYY hh:mm:ss a') }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="Role"
                  v-if="false">
                  <template slot-scope="scope">
                    <edit-role-button :userMembershipId="scope.row.id" :roles="app.roles" :initialCurrentRoleId="scope.row.role.id"><i class="fas fa-pen"></i></edit-role-button>
                  </template>
                </el-table-column>
                <el-table-column label="" width="120">
                  <template slot-scope="scope">
                    <router-link :to="{ name: 'userProfile', params: { id: scope.row.id } }">
                      <el-tooltip effect="dark" content="Go to user's page" placement="bottom">
                        <el-button size="mini" type="primary"><i class="fas fa-search"></i></el-button>
                      </el-tooltip>
                    </router-link>
                    <el-tooltip effect="dark" content="Resend invitation" placement="bottom">
                      <el-button @click="resendInvitation(scope.row.id)" v-if="!scope.row.user || !scope.row.invitation_accepted_at" size="mini"><i class="fas fa-paper-plane"></i></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>

              <content-placeholder v-show="creating">
                <p class="text text-75"></p>
                <p class="text text-50"></p>
                <p class="text text-50"></p>
                <p class="text text-50"></p>
              </content-placeholder>
            </div>
            
            <div v-else>
              <el-alert type="warning" :closable="false" :title="'There are no active users yet.'" center></el-alert>
            </div>

          </el-card>

        </el-col>
        <el-col :md="6">
          <el-card>
            <div slot="header">
              Invite User
            </div>
            <div v-if="activeUsersCount <= 1000000">
              <user-membership-form :app="app"></user-membership-form>
            </div>
            <div v-if="activeUsersCount > 1000000">
              <el-alert type="warning" :closable="false" :title="'You have reached maximum number of users for this application.'" center></el-alert>
            </div>
          </el-card>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import avatar from '@/mixins/avatar';
  // import UserMembership from '@/components/UserMembership';
  import UserMembershipForm from '@/components/userMembership/UserMembershipForm';
  import EditRoleButton from '@/components/role/EditRoleButton';

  export default {
    name: 'InviteUsersPage',
    components: {
      // userMembership: UserMembership,
      userMembershipForm: UserMembershipForm,
      editRoleButton: EditRoleButton,
    },
    mixins: [avatar],
    created() {
      this.fetchSingleApp({ id: this.appId });
      this.fetchUsers({ scope: 'employee' });
    },
    data() {
      return {
        translationPrefix: 'pages.inviteUsers',
        appId: parseInt(this.$router.currentRoute.params.id, 10),
      };
    },
    computed: {
      ...mapGetters('entities/apps', ['fetching']),
      ...mapGetters('entities/userMemberships', ['creating']),

      updating() {
        return this.$store.getters['entities/userMemberships/isUpdating'](this.userMembership.id);
      },
      deleting() {
        return this.$store.getters['entities/userMemberships/isDeleting'](this.userMembership.id);
      },
      count() {
        return this.app.user_memberships ? this.app.user_memberships.length : 0;
      },

      app() {
        return this.$store.getters['entities/apps/query']()
          .with('roles')
          .with('user_memberships.role')
          .first(this.appId);
      },
      subscribedPackage() {
        const appMemberships = this.$store.getters['entities/appMemberships/query']()
          .with('package')
          .where('app_id', this.appId)
          .where('active', true)
          .get();

        return appMemberships && appMemberships.length === 1 ? appMemberships[0].package : null;
      },
      activeUsersCount() {
        return this.app && this.app.user_memberships ? this.app.user_memberships.length : 0;
      },
    },
    methods: {
      ...mapActions('entities/apps', ['fetchSingleApp']),
      ...mapActions('entities/users', ['fetchUsers']),

      resendInvitation(id) {
        this.$confirm('Do you really want to resend an invitation to this user?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.$store.dispatch('entities/userMemberships/resendInvitation', id);
        });
      },
      removeUserMembership(id) {
        this.$confirm('Do you really want to remove the user from this application?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.$store.dispatch('entities/userMemberships/removeUserMembership', id);
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  h2 {
    margin-top: 0;
  }
  .userMembership{
    max-width: 318px;
    display: inline-block;
    vertical-align: top;
    margin: 0 20px 20px 0;
    &:last-child{
      margin-right: 0;
    }
  }
  .image{
    width: 100%;
    max-width: 48px;
    margin: auto;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }
</style>


// WEBPACK FOOTER //
// src/pages/InviteUsers.vue